export function getBateriiuzate ({ state, commit }, { search , page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/bateriiuzate', { params: { search, page } })
      .then((response) => {
        commit('setBateriiuzate', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getViewBateriiuzate ({ state, commit }, buId) {
  return new Promise((resolve, reject) => {
    if (buId) {
      axiosInstance.get('/v1/bateriiuzate/' + buId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No ID'))
    }
  })
}

export function getCreateBateriiuzate ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/bateriiuzate/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createBateriiuzate ({ state, commit }, newbateriiuzate) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/bateriiuzate', newbateriiuzate)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditBateriiuzate ({ state, commit }, buId) {
  return new Promise((resolve, reject) => {
    if (buId) {
      axiosInstance.get('/v1/bateriiuzate/' + buId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No ID'))
    }
  })
}

export function editBateriiuzate ({ state, commit }, { id, accountkey, quantity }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/bateriiuzate/' + id, { accountkey, quantity })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No ID'))
    }
  })
}

export function deleteBateriiuzate ({ state, commit }, buId) {
  return new Promise((resolve, reject) => {
    if (buId) {
      axiosInstance.delete('/v1/bateriiuzate/' + buId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No ID'))
    }
  })
}
